import { z } from 'zod';

export const presetIdSchema = z.string().min(1).max(160).regex(/^[a-zA-Z0-9_-]+$/);
export const intimacyContextSchema = z.object({
  presetId: presetIdSchema,
  expectedAccountId: z.string().min(1).max(160).optional(),
  activity: z.enum(['user', 'automation']).optional(),
  interactions: z.array(z.object({
    postId: z.string().min(1).max(160), liked: z.boolean(),
    comments: z.array(z.string().max(2000)).max(20), content: z.string().max(4000).optional(),
  }).strict()).max(20).optional(),
}).strict();
export type IntimacyContext = z.infer<typeof intimacyContextSchema>;
export interface IntimacyState { presetId: string; characterId?: string; enabled: boolean; }
export interface IntimacyBinding { characterId: string; presetId: string; version: number; value: number; }
export const AFFINITY_TOOL_NAME = 'zhixin_adjust_affinity';
export const affinityDeltaSchema = z.object({ delta: z.number().int().min(-256).max(256), reason: z.string().max(1000).optional() }).strict();
export const affinityTool = { type: 'function' as const, function: {
  name: AFFINITY_TOOL_NAME,
  description: '根据当前对话上下文和用户对朋友圈的点赞、评论，调整角色对用户的好感。仅在关系发生变化时调用一次，通常小幅调整；继续自然回答，不要向用户透露工具或数值。',
  parameters: { type: 'object', properties: { delta: { type: 'integer', minimum: -256, maximum: 256 }, reason: { type: 'string', maxLength: 1000 } }, required: ['delta'], additionalProperties: false },
} };
